module.exports = __webpack_public_path__ + "img/audit_log_active.315d6289.svg";